<template>
    <button @click="tost()">TOAST</button>
    <CoalRend :nft="knft"></CoalRend>
    <button @click="mrerol()">rerol</button>
    <div class="mbody dbody">
        <div class="dholder">

            <div class="dctrl">
                <div>
                    <button class="dele" @click="reload()">reload</button>
                </div>
                <div>
                    <div class="mylist">
                        <div v-for="(fil, filidx) in fils" :key="filidx">
                            <div :class="(filidx == filselected) ? 'dsele' : ''" @click="mselect(filidx, fil)">{{
        fil
}}
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <input class="dele" type="text" v-model="curfilnam" style="color:black" />
                </div>
                <div>
                    <button class="dele" @click="msave()">save</button>
                </div>
                <div>
                    <button class="dele" @click="mdel()">delete</button>
                </div>
            </div>
            <div class="dtxt">

                <textarea @keydown.tab.prevent="" v-model="curfilbody" class="tarea dele">asasd</textarea>
            </div>
            <div class="dctrl">
                <div>
                    <button class="dele">send</button>
                </div>
            </div>
        </div>
        <div class="dholder">
            <div class="dctrl">

                <div @click="debug()">deb</div>
                <span><input type="text" style="color:black" v-model="curkey" /><span
                        @click="addkey()">add</span></span>
                <div v-for="(key, keyidx) in keysets" :key="key">
                    <div>
                        <input v-model="keysets[keyidx].enabled" type="checkbox" />{{ key.name }}
                        <span><input type="text" style="color: black;" :id="'cap_' + key.name" /><span
                                @click="addcap(keyidx)">add</span></span>
                        <div v-for="cap in key.caps" :key="cap">
                            <div>{{ cap.name }}<input type="text" /> </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dctrl">

                asd
            </div>
        </div>
        <div>
            <button @click="reload_emoj()" style="position: sticky;left: 1000px;top: 180px;">reload emoj</button>
            <button @click="export_emoj()" style="position: sticky;left: 1000px;top: 150px;">export emoj</button>
            <button @click="hash_export()" style="position: sticky;left: 1000px;top: 210px;">hash export</button>
            <button @click="load_from_util()" style="position: sticky;left: 1000px;top: 240px;">load from util</button>


            <table>
                <tr v-for="emv, emk, emidx in emojradio" :key="emidx">
                    <td style="font-size: 20pt;">{{ emv.emo }}</td>
                    <td>{{ emk }}</td>
                    <td><button v-bind:class="emv.state == 'HAT' ? 'sele' : ''"
                            @click="save_emoj(emk, 'HAT')">😀</button></td>
                    <td><button v-bind:class="emv.state == 'HAND' ? 'sele' : ''"
                            @click="save_emoj(emk, 'HAND')">🖐</button></td>
                    <td><button v-bind:class="emv.state == 'PET' ? 'sele' : ''"
                            @click="save_emoj(emk, 'PET')">🐥</button></td>
                    <td><button v-bind:class="emv.state == 'SKY' ? 'sele' : ''"
                            @click="save_emoj(emk, 'SKY')">🌛</button></td>
                    <td><button v-bind:class="emv.state == 'BACK' ? 'sele' : ''"
                            @click="save_emoj(emk, 'BACK')">🚪</button></td>
                    <td><button v-bind:class="emv.state == 'NONE' ? 'sele' : ''"
                            @click="save_emoj(emk, 'NONE')">⛔</button></td>

                </tr>
            </table>
        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';
import Pact from 'pact-lang-api';
import CoalRend from './CoalRend.vue';
import { NFTItem, validate_hash } from '@/utility';
// import CoalRend from './CoalRend.vue';

export default {
    name: ENUMS.VIEWS.DEBUG
    // ,components:{CoalRend}
    ,
    methods: {
        validate_hash,
        tost() {
            var qthis = this
            this.$store.commit("addToast", qthis.tt)
            qthis.tt += 1
            console.log(validate_hash('asd'))
        },
        save_emoj(nam, stat) {
            this.emojradio[nam].state = stat;
            localStorage.emojradio = JSON.stringify(this.emojradio);
        },
        hash_export() {
            var a = JSON.parse(localStorage.emojradio);
            var b = Object.keys(a).map(x => [x, a[x]]).filter(x => x[1].state != "NONE");
            var c = b.map(x => [Pact.crypto.hash(x[1].emo), x[1].emo]);
            var d = b.map(x => Pact.crypto.hash(x[1].emo));
            d = d.sort();
            var r = {};
            for (var i in c) {
                r[c[i][0]] = c[i][1];
            }
            console.log(Object.keys(a).length, b.length, d.length, r);
        },
        load_from_util() {
            var tmp = {};
            for (var i in ENUMS.EMOJI2) {
                for (var j in ENUMS.EMOJI2[i]) {
                    tmp[j] = { state: i, emo: ENUMS.EMOJI2[i][j] };
                }
            }
            console.log(tmp);
            localStorage.emojradio = JSON.stringify(tmp);
        },
        reload_emoj() {
            if (localStorage.emojradio) {
                this.emojradio = JSON.parse(localStorage.emojradio);
                // for (var i in tmp) {
                //     this.emojradio[i] = { state: tmp[i] }
                // }
            }
        },
        export_emoj() {
            var tmp = { HAT: {}, HAND: {}, SKY: {}, PET: {}, BACK: {}, NONE: {} };
            for (var i in this.emojradio) {
                tmp[this.emojradio[i].state][i] = this.emojradio[i].emo;
            }
            console.log(tmp);
            localStorage.emojradio = JSON.stringify(tmp);
        },
        mselect(filidx, fil) {
            this.filselected = filidx;
            this.filselectedname = fil;
            this.mfetch("readfil", { name: fil }).then(x => {
                this.curfilbody = x.body;
            });
        },
        mfetch(e, x) {
            return fetch("http://127.0.0.1:8558/" + e, {
                "method": "POST",
                "headers": {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                "body": JSON.stringify(x)
            }).then(x => x.text()).then(x => {
                console.log(9999, x);
                return new Promise((resolve) => resolve(JSON.parse(x)));
            });
        },
        reload() {
            this.mfetch("ls", {}).then(x => {
                console.log(x);
                this.fils = x;
            });
        },
        msave() {
            var qthis = this;
            this.mfetch("savefil", { name: qthis.curfilnam, body: qthis.curfilbody }).then(() => { qthis.reload(); });
        },
        mdel() {
            var qthis = this;
            this.mfetch("delfil", {
                name: qthis.filselectedname
            }).then(() => { console.log(11111); qthis.reload(); });
        },
        addkey() {
            this.keysets.push({ enabled: false, name: this.curkey, caps: [] });
            this.curkey = "";
        },
        addcap(idx) {
            this.keysets[idx].caps.push({ name: document.getElementById("cap_" + this.keysets[idx].name).value });
        },
        debug() {
            console.log(this.keysets);
        }, mrerol() {
            this.knft = new NFTItem(this, { id: { int: 1 }, attrib: Pact.crypto.hash("" + Math.floor(Math.random() * 10000)) })

        }, NFTItem
    },
    data() {
        var emojradio = {};
        for (var i in ENUMS.ALLEMOJS) {
            emojradio[ENUMS.ALLEMOJS[i].name] = { state: "NONE", emo: ENUMS.ALLEMOJS[i].emo };
        }
        return {
            ENUMS: ENUMS,
            tt: 0,
            fils: [{ value: "asd" }],
            filselected: -1,
            curfilnam: "a1",
            curfilbody: "",
            filselectedname: "",
            keysets: [],
            curkey: "",
            emojradio: emojradio,
            knft: new NFTItem(this, { id: { int: 2 } })
        };
    },
    components: { CoalRend }
}

</script>

<style scoped>
.sele {
    background-color: greenyellow;
}

td>button {
    width: 50px;
    height: 40px;
    margin-bottom: 10px;
}

tr:hover {
    background-color: brown;

}

label {
    margin-right: 40px;
}

.mtd {
    padding: 10%;
}

.dsele {
    background-color: darkblue;
}

.mylist>*:hover {
    background-color: brown;
}


.mylist {
    min-height: 200px;
    max-height: 200px;
    font-size: 10px;
}

.dbody {
    padding: 1%;
}

.dtxt {
    flex-grow: 5;
    padding-right: 1%;
}

.dctrl {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.dele {
    width: 100%;
    margin-right: 1%;
}

.dholder {
    display: flex;
    flex-direction: row;
    margin: none;
}

.tarea {
    color: black;
    height: 500px;
}
</style>